import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../services';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-info-integration',
  templateUrl: 'takeaway-order-info-integration.html',
})

export class TakeawayOrderInfoIntegrationPage {
  @Input() display;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals, ) {
  }

  ionViewDidLoad() {

  }

  back() {
    if (this.takeawayServices.quick_create) {
      this.takeawayServices.quick_create = false;
      this.navCtrl.pop();
      this.navCtrl.pop();
    } else {
      this.navCtrl.pop();
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order-info-integration/takeaway-order-info-integration.ts